"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "AccordionHeader", {
    enumerable: true,
    get: function() {
        return AccordionHeader;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _useAccordionHeader = require("./useAccordionHeader");
const _renderAccordionHeader = require("./renderAccordionHeader");
const _useAccordionHeaderStylesstyles = require("./useAccordionHeaderStyles.styles");
const _reactsharedcontexts = require("@fluentui/react-shared-contexts");
const _useAccordionHeaderContextValues = require("./useAccordionHeaderContextValues");
const AccordionHeader = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    const state = (0, _useAccordionHeader.useAccordionHeader_unstable)(props, ref);
    const contextValues = (0, _useAccordionHeaderContextValues.useAccordionHeaderContextValues_unstable)(state);
    (0, _useAccordionHeaderStylesstyles.useAccordionHeaderStyles_unstable)(state);
    (0, _reactsharedcontexts.useCustomStyleHook_unstable)('useAccordionHeaderStyles_unstable')(state);
    return (0, _renderAccordionHeader.renderAccordionHeader_unstable)(state, contextValues);
});
AccordionHeader.displayName = 'AccordionHeader';
